import React, {RefObject} from 'react';
import './PaymentCalendar.css'
import {withTranslation} from "react-i18next";
import {
    ICalendarTotals,
} from "../../models/ISettlementData";
import AccordionHeader from "react-bootstrap/AccordionHeader";
import Accordion from "react-bootstrap/Accordion";
import {Card} from "react-bootstrap";
import AccordionBody from "react-bootstrap/AccordionBody";
import {CurrencyHelper} from "../../helpers/CurrencyHelper";
import {WebCache} from "../../services/WebCache";
import { Link } from 'react-router-dom';



interface IState {
    settlementAccordionRef:RefObject<any>
    pressentedAccordionRef:RefObject<any>
    balanceAccordionRef:RefObject<any>

}

interface IProps{
    title: string,
    totals: ICalendarTotals,
    mode: "month" | "day",
    onClose: (event: any) => void,
    selectedDate?: Date | null,
    settlementPath?: string
}
class CalendarTotal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {

            settlementAccordionRef:React.createRef(),
            pressentedAccordionRef:React.createRef(),
            balanceAccordionRef:React.createRef(),
        }
    }

    componentDidMount() {

    }

    componentWillUnmount() {


    }


    render() {

        // @ts-ignore
        const { t } = this.props;
        const { totals, mode, onClose } = this.props;
        const formatAmount = (amount: number) =>
            Intl.NumberFormat('es-UY', {
                style: 'currency',
                currency: CurrencyHelper.getCurrencySymbol(totals.currency)
            }).format(amount);
        return (
            <div className="card calendar-detail-panel">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <span className="calendar-detail-panel-title">{this.props.title}</span>
                    <a className="cursor-pointer" onClick={onClose}>
                        <i className="fe fe-x"></i>
                    </a>
                </div>
                <div className="card-body">
                    {mode === "month" ? (
                        <>
                            <p className="calendar-detail-panel-subtitle">
                                {t('until')} {new Date().toLocaleDateString('es-ES')}
                            </p>
                            <h2 className="calendar-detail-panel-amount text-orange">
                                {formatAmount(totals.settlementAmount)}
                            </h2>
                            <table className="table calendar-total-detail">
                                <tbody>
                                    <tr>
                                        <td>{t("couponsMovementsSum")}</td>
                                        <td>{formatAmount(totals.couponsMovementsSum)}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("tariffAmount")}</td>
                                        <td className="text-danger">{formatAmount(totals.settlementTariffAmount)}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("taxAmount")}</td>
                                        <td className="text-danger">{formatAmount(totals.settlementTaxAmount)}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("othersDiscountsAmount")}</td>
                                        <td className="text-danger">{formatAmount(totals.settlementOthersAmount)}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("contrapartsAmount")}</td>
                                        <td className="text-danger">{formatAmount(totals.settlementContapartAmount)}</td>
                                    </tr>
                                    <tr className="fw-bold">
                                        <td>{(t("total") + "").toUpperCase()}</td>
                                        <td>{formatAmount(totals.settlementAmount)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    ) : (
                        <>
                            <p className="calendar-detail-panel-subtitle">
                                {t('day')} {this.props.selectedDate?.toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year:'numeric'})}
                            </p>
                            <h2 className="calendar-detail-panel-amount">
                                {formatAmount(totals.settlementAmount)}
                            </h2>
                            <table className="table calendar-total-detail">
                                <tbody>
                                    <tr>
                                        <td>{t("grossAmount")}</td>
                                        <td>{formatAmount(totals.settlementGrossAmount)}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("otherCharges")}</td>
                                        <td className="text-danger">{formatAmount(totals.settlementChargeAmount)}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("tariffAmount")}</td>
                                        <td className="text-danger">{formatAmount(totals.settlementTariffAmount)}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("othersDiscountsAmount")}</td>
                                        <td className="text-danger">{formatAmount(totals.settlementOthersAmount)}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("taxAmount")}</td>
                                        <td className="text-danger">{formatAmount(totals.settlementTaxAmount)}</td>
                                    </tr>
                                    <tr className="fw-bold">
                                        <td>{(t("total") + "").toUpperCase()}</td>
                                        <td>{formatAmount(totals.settlementAmount)}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <Link to={this.props.settlementPath ?? ''} className="btn btn-outline-secondary w-100 mt-2 rounded-pill">
                                {t('pages.calendar.goToSettlement')}
                            </Link>
                        </>
                    )}
                </div>
            </div>
        );
    };



}
export default withTranslation() (CalendarTotal);
